import moment from "moment-timezone";

export const getParams = (data) => {
    let params = {};

    let tz = JSON.parse(localStorage.company).user_timezone_name;
    if (data.duration === "custom") {
        params.start_date = moment(data.start_date).format("YYYY-MM-DDTHH:mm:ss");
        params.end_date = moment(data.end_date).format("YYYY-MM-DDTHH:mm:ss");
    } else if (data.duration === "24HRS") {
        params.end_date = moment(new Date()).tz(tz).format("YYYY-MM-DDTHH:mm:ss");
        params.start_date = moment(new Date())
            .tz(tz)
            .subtract(1440 - 1, "minutes")
            .format("YYYY-MM-DDTHH:mm:ss");
    } else if (data.duration === "lastmonth") {
        params.start_date = moment(new Date()).subtract(1, "month").startOf("month").format("YYYY-MM-DDTHH:mm:ss");
        params.end_date = moment(new Date()).startOf("month").subtract(1, "second").format("YYYY-MM-DDTHH:mm:ss");
    } else if (data.duration === "lastquarter") {
        params.start_date = moment(new Date()).startOf("quarter").subtract(1, "quarter").format("YYYY-MM-DDTHH:mm:ss");
        params.end_date = moment(new Date()).startOf("quarter").subtract(1, "second").format("YYYY-MM-DDTHH:mm:ss");
    } else if (data.duration === "last2quarter") {
        params.start_date = moment(new Date()).startOf("quarter").subtract(2, "quarter").format("YYYY-MM-DDTHH:mm:ss");
        params.end_date = moment(new Date()).startOf("quarter").subtract(1, "second").format("YYYY-MM-DDTHH:mm:ss");
    } else {
        params.end_date = moment(new Date()).tz(tz).format("YYYY-MM-DDTHH:mm:ss");
        params.start_date = moment(new Date())
            .tz(tz)
            .startOf("day")
            .subtract(data.duration - 1, "days")
            .format("YYYY-MM-DDTHH:mm:ss");
        // params.duration = data.duration;
    }

    if (data.duration === "custom" && data.rollingDate) {
        params.end_date = moment(new Date()).tz(tz).format("YYYY-MM-DDTHH:mm:59");
    }

    return params;
};

export const arrangeFilters = (selectedFilters) => {
    let data = {};
    data.start_date = selectedFilters.startDateTime;
    data.end_date = selectedFilters.endDateTime;
    data.rollingDate = selectedFilters.rollingDate;
    data.duration = selectedFilters.duration;
    return data;
};

export const formatPostStatusList = ({ postList }) => {
    let obj = {};
    if (postList?.length < 1 || !postList) return obj;
    else {
        postList.forEach((element) => {
            // if (element.platform !== "linkedin") {
            if (!obj[element.page_id]) {
                obj[element.page_id] = {};
                obj[element.page_id][element.status] = 1;
            } else if (!obj[element.page_id][element.status]) {
                obj[element.page_id][element.status] = 1;
            } else {
                obj[element.page_id][element.status] += 1;
            }
            // }
        });
    }
    return obj;
};

export const formatpostStatusObj = ({ smpPostList, selectedPageOption }) => {
    const statusCount = {
        Published: 0,
        Draft: 0,
        Pending: 0,
        Approved: 0,
        Rejected: 0,
        Failed: 0,
    };
    if (Object.keys(smpPostList).length > 0) {
        let statusLists;
        if (selectedPageOption[0] === "selectAll") {
            statusLists = Object.values(smpPostList);
        } else {
            statusLists = Object.entries(smpPostList)
                .filter(([pageId, statusObj]) => selectedPageOption.includes(pageId))
                .map(([pageId, statusObj]) => statusObj);
        }

        statusLists.forEach((statusObj) => {
            statusCount.Published += (statusObj.PUBLISHED || 0) + (statusObj.PUBLISHING || 0);
            statusCount.Failed += statusObj.FAILED || 0;
            statusCount.Pending += statusObj.PENDING || 0;
            statusCount.Draft += statusObj.DRAFT || 0;
            statusCount.Approved += statusObj.APPROVED || 0;
            statusCount.Rejected += statusObj.REJECTED || 0;
        });
    }
    // if (Object.keys(smpPostList).length > 0) {
    //     const filteredValue =
    //         selectedPageOption[0] === "selectAll"
    //             ? Object.values(smpPostList)
    //             : Object.entries(smpPostList)
    //                   .filter(([pageId, statusObj]) => selectedPageOption.includes(pageId))
    //                   .map(([pageId, statusObj]) => statusObj);

    //     console.log("filteredValue", filteredValue);
    //     filteredValue.forEach((statusObj) => {
    //         statusCount.Published += (statusObj.PUBLISHED || 0) + (statusObj.PUBLISHING || 0);
    //         statusCount.Failed += statusObj.FAILED || 0;
    //         statusCount.Pending += statusObj.PENDING || 0;
    //         statusCount.Draft += statusObj.DRAFT || 0;
    //     });
    // }

    return statusCount;
};
